import { httpPost } from "./httpService";

export function listEntityRelations(entityId) {
  return httpPost("/admin/entityRelation/v1/list", { entityId });
}

export function createEntityRelation(payload) {
  return httpPost("/admin/entityRelation/v1/create", payload);
}

export function updateEntityRelation(payload) {
  return httpPost("/admin/entityRelation/v1/update", payload);
}

export function deleteEntityRelation(relationId, entityId) {
  return httpPost("/admin/entityRelation/v1/delete", { relationId, entityId });
}
